// Multivariate Dependencies
import React from 'react';
// Styles
import { useStyles } from './styles/useStyles';
// Utils
import { classNames } from 'ezyvet-fe-helpers';
/** Link Style button component
 *
 * @deprecated Do not use legacy components anymore.
 * @param {LinkStyleButtonProps} props props
 * @returns {Element} Line style button
 */
var LinkStyleButton = function (_a) {
    var _b;
    var onClickHandler = _a.onClickHandler, disabled = _a.disabled, children = _a.children, elementId = _a.elementId, onMouseOut = _a.onMouseOut, color = _a.color;
    var classes = useStyles({ color: color, children: children });
    return (React.createElement("button", { className: classNames(classes.link, (_b = {}, _b[classes.disabled] = disabled, _b)), onClick: onClickHandler, disabled: disabled, "data-testid": elementId, onMouseOut: onMouseOut, onBlur: onMouseOut, type: 'button', color: color }, children));
};
LinkStyleButton.defaultProps = {
    type: 'button',
    disabled: false,
    elementId: '',
};
export default LinkStyleButton;
//# sourceMappingURL=LinkStyleButton.js.map